var _style, _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMimecastLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 45",
    style: {
      enableBackground: "new 0 0 256 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000026125163552923660500000000051222577147118735_);}\n\t.st1{clip-path:url(#SVGID_00000033342398225955386150000016441380380710670752_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Mimecast_white_logo_00000148634474850149893250000016419222456409396125_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 4,
    y: 0.9,
    width: 249,
    height: 42.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080194796872798764570000017837948045321604256_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080194796872798764570000017837948045321604256_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000127753496698565997140000015843691398580623283_",
    x: 4,
    y: 0.9,
    width: 249,
    height: 42.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158726280116225308680000006533161547290027967_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127753496698565997140000015843691398580623283_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158726280116225308680000006533161547290027967_)",
      fill: "#FFFFFF"
    },
    d: "M4,43.4v-30h29.4 c6.1,0,9.2,3.1,9.2,9.2v20.8h-7.8V22c0-1.2-0.6-1.8-1.8-1.8h-5.7v23.2h-7.8V20.2h-7.6v23.2H4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158726280116225308680000006533161547290027967_)",
      fill: "#FFFFFF"
    },
    d: "M48.3,0.9h8.1v7.6 h-8.1V0.9z M48.4,13.4h7.8v30h-7.8V13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158726280116225308680000006533161547290027967_)",
      fill: "#FFFFFF"
    },
    d: "M63,43.4v-30h29.4 c6.1,0,9.2,3.1,9.2,9.2v20.8h-7.8V22c0-1.2-0.6-1.8-1.8-1.8h-5.7v23.2h-7.8V20.2h-7.5v23.2H63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158726280116225308680000006533161547290027967_)",
      fill: "#FFFFFF"
    },
    d: "M107.4,34.2V22.6 c0-6.1,3.1-9.2,9.2-9.2h7.4c6.1,0,9.2,3.1,9.2,9.2v8.7h-17.9v3.4c0,1.2,0.6,1.8,1.8,1.8h16.1v4.3v2.6h-16.6 C110.4,43.4,107.4,40.3,107.4,34.2 M115.2,25.2h10.1V22c0-1.2-0.6-1.8-1.8-1.8H117c-1.2,0-1.8,0.6-1.8,1.8V25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158726280116225308680000006533161547290027967_)",
      fill: "#FFFFFF"
    },
    d: "M138.7,34.2V22.6 c0-6.1,3.1-9.2,9.2-9.2h14V16v4.3h-13.5c-1.2,0-1.8,0.6-1.8,1.8v12.7c0,1.2,0.6,1.8,1.8,1.8h13.5v4.3v2.6h-14 C141.8,43.4,138.7,40.3,138.7,34.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158726280116225308680000006533161547290027967_)",
      fill: "#FFFFFF"
    },
    d: "M175.9,43.4 c-6.1,0-9.2-3-9.2-9c0-6,3.1-9,9.2-9h7.8V22c0-1.2-0.6-1.8-1.8-1.8h-13.7V16v-2.6h14.1c6.1,0,9.2,3.1,9.2,9.2v20.8H175.9z  M174.6,34.7c0,1.2,0.6,1.8,1.8,1.8h7.4v-5.1h-7.4c-1.2,0-1.8,0.6-1.8,1.8V34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158726280116225308680000006533161547290027967_)",
      fill: "#FFFFFF"
    },
    d: "M197.5,40.8v-4.3 h13.1c1.3,0,1.9-0.7,1.9-2.2c0-1.5-0.6-2.3-1.7-2.5l-6.1-1c-4.8-0.8-7.2-3.6-7.2-8.3c0-6.1,3.1-9.2,9.2-9.2h12.2V16v4.3h-11.7 c-1.3,0-1.9,0.7-1.9,2.2c0,1.5,0.6,2.3,1.7,2.5l6.1,1c4.8,0.8,7.2,3.6,7.2,8.3c0,6.1-3.1,9.2-9.2,9.2h-13.6V40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158726280116225308680000006533161547290027967_)",
      fill: "#FFFFFF"
    },
    d: "M225.2,34.2v-30h7.8 v9.2h9.8v6.8h-9.8v14.5c0,1.2,0.6,1.8,1.8,1.8h8.5v4.3v2.6h-9C228.3,43.4,225.2,40.3,225.2,34.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000158726280116225308680000006533161547290027967_)",
      fill: "#FFFFFF"
    },
    d: "M253,15.4 c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2,2.1-2C252.1,13.4,253,14.3,253,15.4 M249.3,15.4 c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.5-0.7,1.5-1.6c0-0.9-0.7-1.6-1.6-1.6C250,13.8,249.3,14.5,249.3,15.4 M250.6,16.5h-0.5v-2 c0.2,0,0.4-0.1,0.8-0.1c0.4,0,0.6,0.1,0.7,0.1c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2-0.2,0.4-0.4,0.5v0c0.2,0.1,0.3,0.2,0.4,0.5 c0.1,0.3,0.1,0.4,0.1,0.5h-0.5c-0.1-0.1-0.1-0.3-0.2-0.5c0-0.2-0.2-0.3-0.4-0.3h-0.2V16.5z M250.6,15.3h0.2 c0.3,0,0.5-0.1,0.5-0.3c0-0.2-0.1-0.3-0.4-0.3c-0.1,0-0.2,0-0.3,0V15.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMimecastLogo);
export default __webpack_public_path__ + "static/media/mimecast-logo.dc3d5d8ac121c14340bbbc9d7e51462e.svg";
export { ForwardRef as ReactComponent };